module.exports = __webpack_public_path__ + "img/arrow-3.460d04c6.svg";